// @ts-nocheck
// TODO: tighten types after migration
import React from "react";
import './Header.css';
import './index.css';
import { NavLink } from 'react-router-dom';
import { Helmet } from "react-helmet";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useState, useEffect, useRef } from "react";



function openNav() {
    var wid = window.screen.availWidth;
    
    // Mobile devices (phones) - typically 320px to 480px
    if (wid <= 480) {
        document.getElementById("mySidenav").style.width = "100%";
    }
    // Tablet devices - typically 481px to 1024px
    else if (wid <= 1024) {
        document.getElementById("mySidenav").style.width = "35%";
    }
    // Laptop/Desktop devices - 1025px and above
    else {
        document.getElementById("mySidenav").style.width = "20%";
    }
    
    document.getElementById("ham_btn").style.visibility = "hidden";
    
    // Lock body scroll while keeping scrollbar visible
    const scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    document.body.style.overflowY = 'scroll'; // Force scrollbar to stay visible
    
    document.body.classList.add("sidenav-open");
}

function closeNav() {
    document.getElementById("mySidenav").style.width = "0";
    document.getElementsByTagName("BODY")[0].style.marginLeft = "0";
    document.getElementById("ham_btn").style.visibility = "visible";
    
    // Unlock body scroll and restore position
    const scrollY = document.body.style.top;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflowY = '';
    
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
    
    document.body.classList.remove("sidenav-open");
}


function myFunction(event) {
    var clickedElement = event.currentTarget;
    var dropdown = clickedElement.nextElementSibling;
    var arrow = clickedElement.querySelector('.arrow');
    
    // Close all other dropdowns first
    var allDropdowns = document.querySelectorAll('.orderlist, .storelist');
    var allArrows = document.querySelectorAll('.arrow');
    
    allDropdowns.forEach(function(dd) {
        if (dd !== dropdown) {
            dd.style.display = "none";
        }
    });
    
    allArrows.forEach(function(ar) {
        if (ar !== arrow) {
            ar.style.transform = 'rotatex(0deg)';
        }
    });

    // Reset settings icon rotation if we are clicking something else (or even if we are clicking settings, logic handles toggle below)
    // Actually, if we click "Store", we want "Settings" to close and rotate back.
    // So we should find the settings icon and remove the class if we are not opening settings,
    // or if we are closing settings.
    var settingsIcon = document.querySelector('.settings-btn-heading .fi-rr-settings');
    if (settingsIcon && clickedElement !== document.querySelector('.settings-btn-heading')) {
         settingsIcon.classList.remove('rotate-icon');
    }
    
    // Toggle current dropdown
    if (dropdown.style.display === "none" || dropdown.style.display === "") {
        dropdown.style.display = "block";
        arrow.style.transform = 'rotatex(180deg)';
        if (clickedElement.classList.contains('settings-btn-heading')) {
            let iconEl = clickedElement.querySelector('.fi-rr-settings');
            if(iconEl) iconEl.classList.add('rotate-icon');
        }
    } else {
        dropdown.style.display = "none";
        arrow.style.transform = 'rotatex(0deg)';
        if (clickedElement.classList.contains('settings-btn-heading')) {
            let iconEl = clickedElement.querySelector('.fi-rr-settings');
            if(iconEl) iconEl.classList.remove('rotate-icon');
        }
    }
}

function getIsDarkMode() {
    return document.body.classList.contains("dark-mode") || document.documentElement.classList.contains("dark-mode");
}

function changeMode(forceValue) {
    const nextValue = typeof forceValue === "boolean" ? forceValue : !getIsDarkMode();
    document.body.classList.toggle("dark-mode", nextValue);
    document.documentElement.classList.toggle("dark-mode", nextValue);
    return nextValue;
}



function Navigation(){
    const PODCAST_PLAYER_STORAGE_KEY = 'globalPodcastPlayer';
    const location = useLocation();
    const headerRef = useRef(null);
    const [headerHeight, setHeaderHeight] = useState(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [showDynamicNavigation, setShowDynamicNavigation] = useState(false);
    const [dynamicNavExpanded, setDynamicNavExpanded] = useState(false);
    const [isAudioPlayerVisible, setIsAudioPlayerVisible] = useState(false);
    const [audioPlayerHeight, setAudioPlayerHeight] = useState(0);
    const dynamicNavRef = useRef(null);
    const lastScrollY = useRef(0);

    const [isDarkMode, setIsDarkMode] = useState(getIsDarkMode());

    useEffect(() => {
        const syncTheme = () => setIsDarkMode(getIsDarkMode());
        syncTheme();

        const observer = new MutationObserver(syncTheme);
        observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
        observer.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });

        return () => observer.disconnect();
    }, []);

    const handleThemeToggle = () => {
        const next = changeMode(!isDarkMode);
        setIsDarkMode(next);
    };

    // Font settings states and sync logic
    const [fontSize, setFontSize] = useState(() => {
        if (typeof window !== 'undefined') {
            const saved = sessionStorage.getItem('post-font-size');
            if (saved) return saved;
            return window.innerWidth <= 768 ? 'small' : 'medium';
        }
        return 'medium';
    });
    const [readingFamily, setReadingFamily] = useState(() => {
        if (typeof window !== 'undefined') {
            return sessionStorage.getItem('post-reading-family') || 'standard';
        }
        return 'standard';
    });
    const [showFontSettingsPopup, setShowFontSettingsPopup] = useState(false);
    const [isPostPage, setIsPostPage] = useState(false);

    useEffect(() => {
        const parts = location.pathname.split('/').filter(Boolean);
        const matchesPath = parts[0] === 'blog' && parts.length >= 3;
        setIsPostPage(matchesPath || !!window.isPostPageActive);
    }, [location.pathname]);

    useEffect(() => {
        const handleActiveChange = (e) => {
            if (e.detail) {
                const parts = location.pathname.split('/').filter(Boolean);
                const matchesPath = parts[0] === 'blog' && parts.length >= 3;
                setIsPostPage(matchesPath || e.detail.active);
            }
        };
        window.addEventListener('postPageActiveChanged', handleActiveChange);
        return () => window.removeEventListener('postPageActiveChanged', handleActiveChange);
    }, [location.pathname]);

    useEffect(() => {
        const handleFontSettingsUpdate = (e) => {
            if (e.detail) {
                if (e.detail.fontSize) setFontSize(e.detail.fontSize);
                if (e.detail.readingFamily) setReadingFamily(e.detail.readingFamily);
            }
        };
        window.addEventListener('fontSettingsChanged', handleFontSettingsUpdate);
        return () => window.removeEventListener('fontSettingsChanged', handleFontSettingsUpdate);
    }, []);

    const handleFontSizeChange = (size) => {
        setFontSize(size);
        sessionStorage.setItem('post-font-size', size);
        window.dispatchEvent(new CustomEvent('fontSettingsChanged', { detail: { fontSize: size, readingFamily } }));
    };

    const handleReadingFamilyChange = (family) => {
        setReadingFamily(family);
        sessionStorage.setItem('post-reading-family', family);
        window.dispatchEvent(new CustomEvent('fontSettingsChanged', { detail: { fontSize, readingFamily: family } }));
    };

    const handleFontSettingsToggle = () => {
        setShowFontSettingsPopup((prev) => !prev);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dynamicNavRef.current && !dynamicNavRef.current.contains(event.target)) {
                if (showFontSettingsPopup) {
                    setShowFontSettingsPopup(false);
                } else if (dynamicNavExpanded) {
                    setDynamicNavExpanded(false);
                }
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("touchstart", handleClickOutside);
        };
    }, [dynamicNavExpanded, showFontSettingsPopup]);

    useEffect(() => {
        const updateHeight = () => {
            if (headerRef.current) {
                const height = headerRef.current.offsetHeight;
                setHeaderHeight(height);
                document.documentElement.style.setProperty('--site-header-height', `${height}px`);
            }
        };

        const resizeObserver = new ResizeObserver(() => {
            updateHeight();
        });

        if (headerRef.current) {
            resizeObserver.observe(headerRef.current);
        }

        // Initial update and periodic checks for dynamic content
        updateHeight();
        setTimeout(updateHeight, 100);
        setTimeout(updateHeight, 500);
        setTimeout(updateHeight, 1000);

        window.addEventListener('resize', updateHeight);
        return () => {
            window.removeEventListener('resize', updateHeight);
            resizeObserver.disconnect();
        };
    }, []);

    // Scroll state detection for mobile floating navigation button
    useEffect(() => {
        const updateViewportMode = () => {
            const mobile = window.innerWidth <= 768;
            setIsMobile(mobile);
            if (!mobile) {
                setShowDynamicNavigation(false);
                setDynamicNavExpanded(false);
            }
        };

        const handleScroll = () => {
            const mobile = window.innerWidth <= 768;
            if (!mobile) {
                setShowDynamicNavigation(false);
                return;
            }

            const currentScrollY = window.scrollY;
            const shouldShow = currentScrollY > 12;

            setShowDynamicNavigation(shouldShow);
            if (!shouldShow) {
                setDynamicNavExpanded(false);
            }

            lastScrollY.current = currentScrollY;
        };

        updateViewportMode();
        handleScroll();

        window.addEventListener('resize', updateViewportMode);
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            window.removeEventListener('resize', updateViewportMode);
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        setDynamicNavExpanded(false);
    }, [location.pathname]);

    useEffect(() => {
        const syncAudioPlayerState = (incomingState) => {
            if (incomingState && typeof incomingState === 'object') {
                setIsAudioPlayerVisible(!!incomingState.audioPlayerVisible && !!incomingState.currentPodcast);
                return;
            }

            const savedState = sessionStorage.getItem(PODCAST_PLAYER_STORAGE_KEY);
            if (!savedState) {
                setIsAudioPlayerVisible(false);
                return;
            }

            try {
                const parsed = JSON.parse(savedState);
                setIsAudioPlayerVisible(!!parsed.audioPlayerVisible && !!parsed.currentPodcast);
            } catch (_) {
                setIsAudioPlayerVisible(false);
            }
        };

        const handleAudioPlayingChange = (event) => {
            syncAudioPlayerState(event && event.detail ? event.detail : null);
        };

        const handleStorageChange = (event) => {
            if (!event || event.key === PODCAST_PLAYER_STORAGE_KEY) {
                syncAudioPlayerState();
            }
        };

        syncAudioPlayerState();
        window.addEventListener('audioPlayingChange', handleAudioPlayingChange);
        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('audioPlayingChange', handleAudioPlayingChange);
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    // Observe height of audio player when visible to position floating dynamic navigation above it
    useEffect(() => {
        if (!isAudioPlayerVisible) {
            setAudioPlayerHeight(0);
            return;
        }

        let observer = null;
        let timeoutId = null;
        let isCleanedUp = false;

        const startObserving = () => {
            if (isCleanedUp) return;
            const element = document.querySelector('.audio-player');
            if (element) {
                setAudioPlayerHeight(element.offsetHeight);
                observer = new ResizeObserver((entries) => {
                    for (let entry of entries) {
                        setAudioPlayerHeight(entry.target.offsetHeight);
                    }
                });
                observer.observe(element);
            } else {
                timeoutId = setTimeout(startObserving, 50);
            }
        };

        startObserving();

        return () => {
            isCleanedUp = true;
            if (observer) {
                observer.disconnect();
            }
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, [isAudioPlayerVisible]);

    // Update theme-color meta for all browsers based on glassy state and dark mode
    useEffect(() => {
        const updateAllBrowserThemeColors = () => {
            const isDark = document.body.classList.contains('dark-mode');
            let color;
            let statusBarStyle;

            if (showDynamicNavigation) {
                // Keep browser bars aligned with page while floating mobile button is active
                color = isDark ? '#262626' : '#ffffff';
                statusBarStyle = isDark ? 'black' : 'default';
            } else {
                // Default/scroll-down: blue
                color = '#47b5ff';
                statusBarStyle = 'default';
            }

            // Chrome, Edge, Brave, Arc, DuckDuckGo, Samsung Internet, Opera
            const themeColorMeta = document.getElementById('theme-color-meta');
            if (themeColorMeta) themeColorMeta.content = color;

            // Safari 15+ (supports media-based theme-color)
            const themeColorLight = document.getElementById('theme-color-light');
            if (themeColorLight) themeColorLight.content = showDynamicNavigation ? '#ffffff' : '#47b5ff';
            const themeColorDark = document.getElementById('theme-color-dark');
            if (themeColorDark) themeColorDark.content = showDynamicNavigation ? '#262626' : '#47b5ff';

            // Safari iOS status bar style
            const appleStatusBar = document.getElementById('apple-status-bar-style');
            if (appleStatusBar) appleStatusBar.content = statusBarStyle;

            // Edge/IE legacy
            const msNavColor = document.getElementById('ms-nav-color');
            if (msNavColor) msNavColor.content = color;

            // Fallback: also update any non-ID theme-color metas (e.g. injected by Helmet)
            document.querySelectorAll("meta[name='theme-color']:not([id])").forEach(meta => {
                meta.content = color;
            });
        };
        updateAllBrowserThemeColors();

        // Re-update when dark mode toggled
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'class') {
                    updateAllBrowserThemeColors();
                }
            });
        });
        observer.observe(document.body, { attributes: true });

        return () => observer.disconnect();
    }, [showDynamicNavigation]);

    const handleDynamicNavToggle = () => {
        setDynamicNavExpanded((prev) => !prev);
    };

    const openNavFromDynamicButton = () => {
        setShowFontSettingsPopup(false);
        setDynamicNavExpanded(false);
        openNav();
    };

    const scrollToTop = () => {
        setShowFontSettingsPopup(false);
        setDynamicNavExpanded(false);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const getBottomOffset = () => {
        if (!isAudioPlayerVisible) {
            return window.innerWidth <= 480 ? '20px' : '24px';
        }
        return `${audioPlayerHeight + (window.innerWidth <= 480 ? 20 : 24)}px`;
    };

    return(
        <>
            {/* Spacer keeps page content below the fixed header when it is visible. */}
            <div
                className="header-spacer"
                style={{ height: isMobile && showDynamicNavigation ? '0px' : `${Math.max(headerHeight, 45)}px` }}
            ></div>

            <div className={`fixed top-0 left-0 w-full z-[1000]${showDynamicNavigation && isMobile ? ' mobile-header-hidden opacity-0 pointer-events-none' : ''}`} id="main" ref={headerRef}>
                <div className="w-full max-w-[2000px] mx-auto min-h-fit py-[0.1%] bg-bg border-0 border-b border-solid border-slider flex justify-between items-center z-[1] md:static">
                    <div className="flex items-center gap-[12px] min-[480px]:gap-[16px] md:gap-[20px] ml-[15px]">
                        <a href="https://www.harivishnu.in/" className="flex items-center">
                            <img className="m-0 w-[20px] min-[480px]:w-[24px] md:w-[25px] rounded-[5px]" src="/images/home_images/Logo_Transparent.png" alt="" />
                        </a>
                        <a href="https://blog.harivishnu.in" className="no-underline text-header-link hover:text-primary-cyan font-bold transition-colors duration-200 text-[13.2px] min-[480px]:text-[15.4px] md:text-[17.6px]">
                            Blog
                        </a>
                        <a href="https://podcast.harivishnu.in" className="no-underline text-header-link hover:text-primary-cyan font-bold transition-colors duration-200 text-[13.2px] min-[480px]:text-[15.4px] md:text-[17.6px]">
                            Podcast
                        </a>
                        <a href="https://store.harivishnu.in" className="no-underline text-header-link hover:text-primary-cyan font-bold transition-colors duration-200 text-[13.2px] min-[480px]:text-[15.4px] md:text-[17.6px]">
                            Store
                        </a>
                    </div>

                    <span onClick={openNav} className="cursor-pointer">
                        <div className="w-auto p-[5px] rounded-[5px] mr-[15px] cursor-pointer min-h-[44px] min-w-[44px] flex flex-col items-center justify-center touch-none gap-0 hover:scale-120 transition-transform duration-300" id="ham_btn">
                            <i className="fi fi-rs-burger-menu text-[24px] leading-none text-primary-cyan transition-all duration-300 hover:scale-120"></i>
                        </div>
                    </span>
                </div>
            </div>

             {isMobile && showDynamicNavigation && (
                <div 
                    ref={dynamicNavRef} 
                    className={`fixed ${dynamicNavExpanded ? 'left-1/2 -translate-x-1/2 items-center justify-center' : 'right-[16px] max-[480px]:right-[12px]'} z-[2000] flex items-end transition-all duration-500`}
                    style={{ bottom: getBottomOffset() }}
                >
                    
                    {dynamicNavExpanded && showFontSettingsPopup && (
                        <div className="header-font-settings-popup header-font-settings-popup-bottom-arrow">
                            {/* Text Size Section */}
                            <div className="font-settings-section flex flex-col">
                                <div className="font-settings-label mb-[10px] text-center text-[0.9rem] font-[500] text-[#666] dark-mode:text-[#aaa]">Text Size</div>
                                <div className="font-size-options flex flex-row items-center justify-center gap-[15px]">
                                    {[
                                        { id: 'small', label: 'Small', iconClass: 'fi fi-br-a', sizeClass: 'small-icon' },
                                        { id: 'medium', label: 'Medium', iconClass: 'fi fi-br-a', sizeClass: 'medium-icon' },
                                        { id: 'large', label: 'Large', iconClass: 'fi fi-br-a', sizeClass: 'large-icon' }
                                    ].map((size) => (
                                        <button
                                            key={size.id}
                                            type="button"
                                            className={`font-size-option flex items-center justify-center rounded-[6px] border-none bg-transparent p-[6px] text-[#555] transition-all duration-200 hover:bg-black/5 dark-mode:text-[#bbb] dark-mode:hover:bg-white/10 ${fontSize === size.id ? 'active bg-[#e7f5ff] text-[#47b5ff] dark-mode:bg-[rgba(71,181,255,0.2)] dark-mode:text-[#4dabf7]' : ''}`}
                                            onClick={() => handleFontSizeChange(size.id)}
                                            title={`${size.label} Font Size`}
                                        >
                                            <i className={`${size.iconClass} ${size.sizeClass}`}></i>
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <div className="font-settings-divider my-[12px] h-[1px] bg-[#eee] dark-mode:bg-[#444]"></div>

                            {/* Reading Theme Section */}
                            <div className="font-settings-section flex flex-col">
                                <div className="font-settings-label mb-[8px] text-center text-[0.9rem] font-[500] text-[#666] dark-mode:text-[#aaa]">Reading Theme</div>
                                <div className="theme-options flex flex-row items-center justify-center gap-[15px]">
                                    {/* Standard B&W Toggle */}
                                    <button
                                        type="button"
                                        className={`theme-option relative flex items-center justify-center rounded-full border-2 border-transparent bg-transparent p-[2px] outline-none transition-all duration-200 ${readingFamily === 'standard' ? 'active border-[#47b5ff] bg-[rgba(71,181,255,0.1)] dark-mode:border-[#4dabf7] dark-mode:bg-[rgba(71,181,255,0.2)]' : ''}`}
                                        onClick={() => handleReadingFamilyChange('standard')}
                                        title="Standard"
                                    >
                                        <div 
                                            className="theme-circle w-[24px] h-[24px] rounded-full"
                                            style={{ background: 'linear-gradient(45deg, #ffffff 50%, #000000 50%)', border: '1px solid #ddd' }}
                                        ></div>
                                    </button>

                                    {/* Custom Colors Toggle */}
                                    <button
                                        type="button"
                                        className={`theme-option relative flex items-center justify-center rounded-full border-2 border-transparent bg-transparent p-[2px] outline-none transition-all duration-200 ${readingFamily === 'warm' ? 'active border-[#47b5ff] bg-[rgba(71,181,255,0.1)] dark-mode:border-[#4dabf7] dark-mode:bg-[rgba(71,181,255,0.2)]' : ''}`}
                                        onClick={() => handleReadingFamilyChange('warm')}
                                        title="Warm/Deep Dark"
                                    >
                                        <div 
                                            className="theme-circle w-[24px] h-[24px] rounded-full"
                                            style={{ background: 'linear-gradient(45deg, #FFF8DE 50%, #101010 50%)', border: '1px solid #ddd' }}
                                        ></div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className={`flex items-center justify-center ${dynamicNavExpanded ? 'w-auto max-w-[calc(100vw-20px)] h-auto min-h-[50px] justify-start p-[4px_7px] gap-[8px] overflow-hidden flex-nowrap' : 'h-[50px] px-[8px] min-w-[52px]'} rounded-full border border-white/42 bg-white/44 text-text backdrop-blur-[14px] shadow-lg relative overflow-hidden transition-all duration-[340ms] cubic-bezier(0.2, 0.8, 0.2, 1) dark-mode:border-white/22 dark-mode:bg-[rgba(38,38,38,0.62)] dark-mode:text-[#f4f4f4]`}>
                        {!dynamicNavExpanded ? (
                            <>
                                <button
                                    type="button"
                                    className="border-0 bg-transparent text-inherit flex items-center justify-center min-w-[36px] min-h-[36px] rounded-full cursor-pointer"
                                    onClick={handleDynamicNavToggle}
                                    aria-expanded={dynamicNavExpanded}
                                    aria-label="Expand dynamic mobile navigation"
                                >
                                    <i className="fi fi-br-menu-burger text-[20px] flex items-center"></i>
                                </button>
                            </>
                        ) : (
                            <>
                                <div className="flex items-center gap-[8px] max-w-[calc(100vw-40px)] overflow-x-auto overflow-y-hidden scrollbar-none -ms-overflow-none rounded-full">
                                    {isPostPage && (
                                        <div className="page-settings flex items-center gap-[8px] flex-shrink-0">
                                            <button
                                                type="button"
                                                className={`border-0 rounded-full w-[35px] h-[35px] flex items-center justify-center cursor-pointer transition-all duration-250 flex-shrink-0 ${showFontSettingsPopup ? 'bg-[#47b5ff] text-white dark-mode:bg-[#4dabf7]' : 'bg-white/45 text-text hover:bg-white/60 dark-mode:bg-white/14 dark-mode:text-[#f4f4f4] dark-mode:hover:bg-white/25'}`}
                                                onClick={handleFontSettingsToggle}
                                                aria-expanded={showFontSettingsPopup}
                                                aria-label="Toggle Font Settings"
                                            >
                                                <i className="fi fi-rr-text-box-edit text-[18px] flex items-center"></i>
                                            </button>
                                            <div className="w-[1px] h-[20px] bg-black/15 dark-mode:bg-white/20 mx-[2px] self-center flex-shrink-0"></div>
                                        </div>
                                    )}

                                    <a className="border-0 rounded-[15px] px-[10px] py-[4px] bg-white/45 text-text no-underline flex items-center gap-[6px] text-[14px] leading-none cursor-pointer min-h-[35px] flex-shrink-0 transition-all duration-250 hover:bg-white/60 max-[480px]:px-[10px] max-[480px]:text-[13px] dark-mode:bg-white/14 dark-mode:text-[#f4f4f4] dark-mode:hover:bg-white/25 font-semibold" href="https://www.harivishnu.in/" onClick={() => { setDynamicNavExpanded(false); setShowFontSettingsPopup(false); }} aria-label="Go to home page">
                                        <img className="w-[24px] h-[24px] object-contain rounded-[5px] block flex-shrink-0" src="/images/home_images/Logo_Transparent.png" alt="" />
                                        <span>Home</span>
                                    </a>

                                    <button type="button" className="border-0 rounded-[15px] px-[10px] py-[4px] bg-white/45 text-text no-underline flex items-center gap-[6px] text-[14px] leading-none cursor-pointer min-h-[35px] flex-shrink-0 transition-all duration-250 hover:bg-white/60 max-[480px]:px-[10px] max-[480px]:text-[13px] dark-mode:bg-white/14 dark-mode:text-[#f4f4f4] dark-mode:hover:bg-white/25 font-semibold" onClick={openNavFromDynamicButton} aria-label="Open menu">
                                        <i className="fi fi-br-menu-burger text-[16px] flex items-center"></i>
                                        <span>Menu</span>
                                    </button>

                                    <button type="button" className="border-0 rounded-[15px] px-[10px] py-[4px] bg-white/45 text-text no-underline flex items-center gap-[6px] text-[14px] leading-none cursor-pointer min-h-[35px] flex-shrink-0 transition-all duration-250 hover:bg-white/60 max-[480px]:px-[10px] max-[480px]:text-[13px] dark-mode:bg-white/14 dark-mode:text-[#f4f4f4] dark-mode:hover:bg-white/25 font-semibold" onClick={scrollToTop} aria-label="Scroll to top of page">
                                        <i className="fi fi-rr-arrow-small-up text-[20px] flex items-center"></i>
                                        <span>Top</span>
                                    </button>

                                    <div className="w-[1px] h-[20px] bg-black/15 dark-mode:bg-white/20 mx-[2px] self-center flex-shrink-0"></div>

                                    <button 
                                        type="button" 
                                        className="border-0 rounded-full w-[35px] h-[35px] flex items-center justify-center cursor-pointer transition-all duration-250 flex-shrink-0 bg-white/45 text-text hover:bg-white/60 dark-mode:bg-white/14 dark-mode:text-[#f4f4f4] dark-mode:hover:bg-white/25" 
                                        onClick={handleThemeToggle} 
                                        aria-label="Toggle Dark Mode"
                                    >
                                        {isDarkMode ? (
                                            <i className="fi fi-sr-brightness text-[18px] flex items-center"></i>
                                        ) : (
                                            <i className="fi fi-sr-moon-stars text-[18px] flex items-center"></i>
                                        )}
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}

        </>
    )
}

// Global function to update user in header
window.updateHeaderUser = null;

function SideNav(){
    // eslint-disable-next-line no-unused-vars
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [isDarkMode, setIsDarkMode] = useState(getIsDarkMode());
    const location = useLocation();

    useEffect(() => {
        // Load user info on component mount
        // Load user info on component mount
        const storedUser = sessionStorage.getItem("user");
        if (storedUser && storedUser !== "undefined") {
            setUser(JSON.parse(storedUser));
        } else {
            setUser(null);
        }



        // Listen for login/logout and profile updates
        const syncUser = () => {
            const updatedUser = sessionStorage.getItem("user");
            if (updatedUser && updatedUser !== "undefined") {
                setUser(JSON.parse(updatedUser));
            } else {
                setUser(null);
            }
        };
        
        // Listen for immediate user updates (same tab)
        const handleUserUpdate = (event) => {
            // User updated event received
            setUser(event.detail);
        };
        
        // Set up global function to update user
        window.updateHeaderUser = (newUser) => {
            // Global update function called
            setUser(newUser);
        };
        
        window.addEventListener("storage", syncUser);
        window.addEventListener("userUpdated", handleUserUpdate);

        return () => {
            window.removeEventListener("storage", syncUser);
            window.removeEventListener("userUpdated", handleUserUpdate);
            window.updateHeaderUser = null;
        };
    }, []);

    useEffect(() => {
        const syncTheme = () => setIsDarkMode(getIsDarkMode());
        syncTheme();

        const observer = new MutationObserver(syncTheme);
        observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
        observer.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });

        return () => observer.disconnect();
    }, []);

    // Close Sidenav on Escape key press
    useEffect(() => {
        const handleEsc = (event) => {
            if (event.key === "Escape" || event.key === "Esc" || event.keyCode === 27) {
                closeNav();
            }
        };

        window.addEventListener("keydown", handleEsc);

        return () => {
            window.removeEventListener("keydown", handleEsc);
        };
    }, []);


    const handleLogout = () => {
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        setUser(null);
        // navigate("/login", { state: { from: location } });
        closeNav();
        window.location.href = "/signin";  // ✅ Force reload & redirect after logout
    };

    const handleThemeToggle = () => {
        const next = changeMode(!isDarkMode);
        setIsDarkMode(next);
    };



    return(      
        <>  
        <div id="mySidenav" className="h-full h-[100dvh] w-0 fixed top-0 right-0 rounded-bl-[15px] rounded-tl-[15px] bg-bg overflow-x-hidden overflow-y-auto transition-all duration-500 z-[9999]">
            <div className="flex flex-row items-center justify-end">
                <i id="close_btn" className="fi fi-rr-cross-small relative flex items-center justify-center w-fit text-[#ff8c00] border border-[#ff8c00] rounded-[5px] m-[15px_15px_15px_15px] text-[25px] transition-all duration-300 hover:text-[#ff8c00] hover:border-[#ff8c00] hover:bg-[rgba(255,140,0,0.12)] cursor-pointer" onClick={closeNav}>
                    <span className="shortcut-badge">Esc</span>
                </i>
            </div>

            <hr className="h-[1.5px] w-[90%] mx-auto bg-slider border-0 opacity-80" />

            {/* --- LOGIN/OUT/PROFILE --- */}
            {user ? (
                <>
                    <div className="py-[8px] px-[10px] my-[5px] mx-[15px] no-underline text-[20px] text-gray-888 flex flex-row items-center transition-300 rounded-[7px] min-h-[44px] min-w-[44px] touch-none">
                        <i className="fi fi-rr-skill-user flex items-center justify-center ml-[5px] transition-transform duration-300 h-[25px] w-[25px]"></i>
                        <p className="mt-[2px] ml-[4px]">Hello, {user.name}</p>
                    </div>
                    <NavLink className="py-[8px] px-[10px] my-[5px] mx-[15px] no-underline text-[20px] text-gray-888 flex flex-row items-center transition-300 rounded-[7px] min-h-[44px] min-w-[44px] touch-none hover:text-primary-cyan hover:bg-hover" to="/edit-profile" onClick={closeNav}>
                        <i className="fi fi-rr-admin-alt flex items-center justify-center ml-[5px] transition-transform duration-300 h-[25px] w-[25px]"></i>
                        <p className="mt-[2px] ml-[4px]">Edit Profile</p>
                    </NavLink>
                    {/* Admin Dashboard Button */}
                    {(user.role === "admin" || user.role === "staff") && (
                        <NavLink className="py-[8px] px-[10px] my-[5px] mx-[15px] no-underline text-[20px] text-gray-888 flex flex-row items-center transition-300 rounded-[7px] min-h-[44px] min-w-[44px] touch-none hover:bg-primary-cyan hover:text-white" to="/admin" onClick={closeNav}>
                            <i className="fi fi-rr-dashboard flex items-center justify-center ml-[5px] transition-transform duration-300 h-[25px] w-[25px]"></i>
                            <p className="mt-[2px] ml-[4px]">Admin Dashboard</p>
                        </NavLink>
                    )}
                    <div className="py-[8px] px-[10px] my-[5px] mx-[15px] no-underline text-[20px] text-[#FE4F2D] flex flex-row items-center transition-300 rounded-[7px] min-h-[44px] min-w-[44px] touch-none hover:text-[#FE4F2D] hover:bg-hover cursor-pointer" onClick={handleLogout}>
                        <i className="fi fi-rr-person-to-door flex items-center justify-center ml-[5px] transition-transform duration-300 h-[25px] w-[25px]"></i>
                        <p className="mt-[2px] ml-[4px]">Logout</p>
                    </div>
                </>
            ) : (
                <>
                    <NavLink className="py-[8px] px-[10px] my-[5px] mx-[15px] no-underline text-[20px] text-gray-888 flex flex-row items-center transition-300 rounded-[7px] min-h-[44px] min-w-[44px] touch-none hover:text-primary-cyan hover:bg-hover cursor-pointer" to="/signin" state={{ from: location }} onClick={closeNav}>
                        <i className="fi fi-rr-person-simple flex items-center justify-center ml-[5px] transition-transform duration-300 h-[25px] w-[25px]"></i>
                        <p className="mt-[2px] ml-[4px]">Login / Register</p>
                    </NavLink>
                </>
            )}

            <hr className="h-[1px] w-[90%] mx-auto bg-slider border-0 opacity-80" />


            <a className="py-[8px] px-[10px] my-[5px] mx-[15px] no-underline text-[20px] text-gray-888 flex flex-row items-center transition-300 rounded-[7px] min-h-[44px] min-w-[44px] touch-none hover:text-primary-cyan hover:bg-hover" href="https://www.harivishnu.in/" onClick={closeNav}>
                <i className="fi fi-rr-home flex items-center justify-center ml-[5px] transition-transform duration-300 h-[25px] w-[25px]"></i>
                <p className="mt-[2px] ml-[4px]">Home</p>
            </a>

            <a className="py-[8px] px-[10px] my-[5px] mx-[15px] no-underline text-[20px] text-gray-888 flex flex-row items-center transition-300 rounded-[7px] min-h-[44px] min-w-[44px] touch-none hover:text-primary-cyan hover:bg-hover" href="https://blog.harivishnu.in" onClick={closeNav}>
                <i className="fi fi-rr-document-signed flex items-center justify-center ml-[5px] transition-transform duration-300 h-[25px] w-[25px]"></i>
                <p className="mt-[2px] ml-[4px]">Blog</p>
            </a>

            <a className="py-[8px] px-[10px] my-[5px] mx-[15px] no-underline text-[20px] text-gray-888 flex flex-row items-center transition-300 rounded-[7px] min-h-[44px] min-w-[44px] touch-none hover:text-primary-cyan hover:bg-hover" href="https://podcast.harivishnu.in" onClick={closeNav}>
                <i className="fi fi-rr-radio flex items-center justify-center ml-[5px] transition-transform duration-300 h-[25px] w-[25px]"></i>
                <p className="mt-[2px] ml-[4px]">Podcast</p>
            </a>

            <a className="py-[8px] px-[10px] my-[5px] mx-[15px] no-underline text-[20px] text-gray-888 flex flex-row items-center transition-300 rounded-[7px] min-h-[44px] min-w-[44px] touch-none hover:text-primary-cyan hover:bg-hover" href="https://www.harivishnu.in/contact" onClick={closeNav}>
                <i className="fi fi-rr-address-book flex items-center justify-center ml-[5px] transition-transform duration-300 h-[25px] w-[25px]"></i>
                <p className="mt-[2px] ml-[4px]">Contact</p>
            </a>

            <div className="relative">
                <div className="py-[8px] px-[10px] my-[5px] mx-[15px] no-underline text-[20px] text-gray-888 flex flex-row items-center transition-300 rounded-[7px] min-h-[44px] min-w-[44px] touch-none hover:text-primary-cyan hover:bg-hover cursor-pointer store-btn-heading" onClick={myFunction}>
                    <i className="fi fi-rs-store-alt flex items-center justify-center ml-[5px] transition-transform duration-300 h-[25px] w-[25px]"></i>
                    <p className="mt-[2px] ml-[4px]">Store</p>
                    <i className="fi fi-rr-caret-down arrow ml-auto"></i>
                </div>
                <div className="storelist flex flex-col m-[0_10px_0_35px]" style={{display: "none"}}>
                    <a className="py-[8px] px-[10px] my-[5px] mx-[0] no-underline text-[20px] text-gray-888 flex flex-row items-center border-l-[1px] border-slider-color rounded-r-[7px] m-[0_10px_0_0] transition-300 hover:text-primary-cyan hover:bg-hover hover:border-b hover:border-slider-color hover:rounded-br-[10px] last:border-b last:border-slider-color" href="https://store.harivishnu.in" onClick={closeNav}>
                        <i className="fi fi-rr-box-open-full flex items-center justify-center ml-[5px] transition-transform duration-300 h-[25px] w-[25px]"></i>
                        <p className="ml-[8px] leading-[1.15]">Products</p>
                    </a>
                    <a className="py-[8px] px-[10px] my-[5px] mx-[0] no-underline text-[20px] text-gray-888 flex flex-row items-center border-l-[1px] border-slider-color rounded-r-[7px] m-[0_10px_0_0] transition-300 hover:text-primary-cyan hover:bg-hover hover:border-b hover:border-slider-color hover:rounded-br-[10px] last:border-b last:border-slider-color" href="https://store.harivishnu.in/cart" onClick={closeNav}>
                        <i className="fi fi-rr-shopping-cart flex items-center justify-center ml-[5px] transition-transform duration-300 h-[25px] w-[25px]"></i>
                        <p className="ml-[8px] leading-[1.15]">Cart</p>
                    </a>
                    <a className="py-[8px] px-[10px] my-[5px] mx-[0] no-underline text-[20px] text-gray-888 flex flex-row items-center border-l-[1px] border-slider-color rounded-r-[7px] m-[0_10px_0_0] transition-300 hover:text-primary-cyan hover:bg-hover hover:border-b hover:border-slider-color hover:rounded-br-[10px] last:border-b last:border-slider-color" href="https://store.harivishnu.in/order-history" onClick={closeNav}>
                        <i className="fi fi-rr-search-alt flex items-center justify-center ml-[5px] transition-transform duration-300 h-[25px] w-[25px]"></i>
                        <p className="ml-[8px] leading-[1.15]">Order History</p>
                    </a>
                </div>
            </div>
                        

            <div className="relative">
                <div className="py-[8px] px-[10px] my-[5px] mx-[15px] no-underline text-[20px] text-gray-888 flex flex-row items-center transition-300 rounded-[7px] min-h-[44px] min-w-[44px] touch-none hover:text-primary-cyan hover:bg-hover cursor-pointer settings-btn-heading" onClick={myFunction}>
                    <i className="fi fi-rr-settings flex items-center justify-center ml-[5px] transition-transform duration-300 h-[25px] w-[25px]"></i>
                    <p className="mt-[2px] ml-[4px]">Settings</p>
                    <i className="fi fi-rr-caret-down arrow ml-auto"></i>
                </div>
                <div className="orderlist flex flex-col m-[0_10px_0_35px]" style={{display: "none"}}>
                    <div className="py-[8px] px-[10px] my-[5px] mx-[0] no-underline text-[20px] text-gray-888 flex flex-row items-center border-l-[1px] border-slider-color rounded-r-[7px] m-[0_10px_0_0] transition-300 hover:text-primary-cyan hover:bg-hover hover:border-b hover:border-slider-color hover:rounded-br-[10px] theme-btn last:border-b last:border-slider-color">
                        <i className="fi fi-rr-paint-roller flex items-center justify-center ml-[5px] transition-trans form duration-300 h-[25px] w-[25px]"></i>
                        <p className="ml-[8px] leading-[1.15]">Dark Theme</p>
                        <label className="theme-toggle-switch ml-auto mr-[10px]" aria-label="Toggle dark theme">
                            <input
                                type="checkbox"
                                className="theme-toggle-input"
                                id="toggle"
                                checked={isDarkMode}
                                onChange={handleThemeToggle}
                            />
                            <span className="theme-toggle-track" aria-hidden="true">
                                <span className="theme-toggle-thumb"></span>
                            </span>
                        </label>
                    </div>
                    <div className="py-[8px] px-[10px] my-[5px] mx-[0] no-underline text-[20px] text-gray-888 flex flex-row items-center border-l-[1px] border-slider-color rounded-r-[7px] m-[0_10px_0_0] transition-300 hover:text-primary-cyan hover:bg-hover hover:border-b hover:border-slider-color hover:rounded-br-[10px] language-btn last:border-b last:border-slider-color">
                        <i className="fi fi-rr-language-exchange flex items-center justify-center ml-[5px] transition-transform duration-300 h-[25px] w-[25px]"></i>
                        <p className="ml-[8px] leading-[1.15]">Language: English</p>
                    </div>
                </div>
            </div>

            <hr className="h-[1px] w-[90%] mx-auto bg-slider border-0 opacity-80" />

            <a className="py-[8px] px-[10px] my-[5px] mx-[15px] no-underline text-[20px] text-gray-888 flex flex-row items-center transition-300 rounded-[7px] min-h-[44px] min-w-[44px] touch-none hover:text-primary-cyan hover:bg-hover" href="https://apps.harivishnu.in" onClick={closeNav}>
                <i className="fi fi-rr-apps flex items-center justify-center ml-[5px] transition-transform duration-300 h-[25px] w-[25px]"></i>
                <p className="mt-[2px] ml-[4px]">All Apps</p>
            </a>

            <NavLink className="py-[8px] px-[10px] my-[5px] mx-[15px] no-underline text-[20px] text-gray-888 flex flex-row items-center transition-300 rounded-[7px] min-h-[44px] min-w-[44px] touch-none hover:text-primary-cyan hover:bg-hover" to="/subscription" onClick={closeNav}>
                <i className="fi fi-rs-receipt flex items-center justify-center ml-[5px] transition-transform duration-300 h-[25px] w-[25px]"></i>
                <p className="mt-[2px] ml-[4px]">Subscription</p>
            </NavLink>

        </div>

        </>
    )
}




export default function Header(){
    return(
        <>
            <Helmet>
                {/* Google Ads */}
                <script
                    async
                    src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7392648336103424"
                    crossOrigin="anonymous"
                ></script>
            </Helmet>
            <Navigation />
            <SideNav />
        </>
    )
}
